import { render, staticRenderFns } from "./DataProcessorCandidatesDataForm.vue?vue&type=template&id=b7cdb0f0&scoped=true"
import script from "./DataProcessorCandidatesDataForm.vue?vue&type=script&lang=js"
export * from "./DataProcessorCandidatesDataForm.vue?vue&type=script&lang=js"
import style0 from "./DataProcessorCandidatesDataForm.vue?vue&type=style&index=0&id=b7cdb0f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7cdb0f0",
  null
  
)

export default component.exports